import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BuyersApi } from 'api';

/**
 * Custom React Query hook to delete a buyer
 *
 * @param {{ onSuccess?: () => void; onError?: (error: Error) => void }} options
 * @returns {import("@tanstack/react-query").UseMutationResult}
 */
export function useDeleteBuyer({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => BuyersApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['buyers']);
      typeof onSuccess === 'function' && onSuccess();
    },
    onError: (error) => {
      typeof onError === 'function' && onError(error);
    },
  });
}
